import { render, staticRenderFns } from "./ReassuranceBlock.vue?vue&type=template&id=5571c9d5&"
import script from "./ReassuranceBlock.vue?vue&type=script&lang=js&"
export * from "./ReassuranceBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports